import { makeStyles } from '@mui/styles';
const useBillingCredentialItemStyles = makeStyles({
  utilityCredentialItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiFormControl-root:not(:last-child)': {
      marginBottom: '12px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent !important'
    }
  },
  utilityCredentialItemCredentialSection: {
    display: 'flex',
    marginBottom: '12px'
  },
  utilityCredentialItemCredentialDetails: {
    width: '50%',
    maxWidth: '100%',
    flexGrow: '1',
    marginRight: '12px'
  },
  utilityCredentialUsernamePasswordSection: {
    display: 'flex',
    flexDirection: 'row',
    '& .MuiFormControl-root:first-child': {
      marginRight: '12px'
    }
  },
  utilityCredentialItemCredentialQuestions: {
    width: '50%',
    '& .MuiFormControl-root:not(:last-child)': {
      marginBottom: '12px'
    }
  },
  utilityCredentialItemReportSection: {
    width: '100%',
    '& .MuiChip-root': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    }
  },
  utilityCredentialItemReportChipChildren: {
    display: 'flex',
    alignItems: 'baseline'
  },
  utilityCredentialItemReportLabel: {
    marginRight: '6px'
  },
  inputToPreviewStyle: {
    '& .MuiFormControl-root': {
      '& .MuiInputBase-root': {
        paddingTop: '10px'
      },
      '& .MuiFormLabel-root': {
        top: '14px'
      }
    }
  }
});
export default useBillingCredentialItemStyles;